//Purifier
import '../plugins/purifier';

import { Component, h } from 'preact';

import { $axiosL } from '../plugins/axios';
import config from '../../config.json'

import { Howl, Howler } from 'howler';

import { connect } from 'redux-zero/preact';
import actions from '../store/actions';

// Component
import Option from './Option';
import CompleteLayout from './CompleteLayout';
import Result from './Result';
import Timer from './Timer';
import Debug from './Debug';
import { classNames } from "../utils/classname";

import { PlayCircleIcon, PauseCircleIcon, RightIcon, RepeatIcon, RefreshIcon } from './icon';
import { $lang, allowFromHosts, hasLastQuestion, setFormData, isComplete } from '../plugins/helper';

const mapToProps = ({
    etest,
    selected,
    email,
    token,
    type,
    playSoundCount,
    sounds,
    playSoundOnStart,
    finishTest,
    isPlaying,
    texts,
    level,
    selectedOption,
    fullname,
    dial_code,
    phone_number,
    debug,
    images,
    isEtest,
    devMode,
    pre_test,
    attempt_of_test,
    certificate_plan
}) => ({
    etest,
    selected,
    email,
    token,
    type,
    playSoundCount,
    sounds,
    playSoundOnStart,
    finishTest,
    isPlaying,
    texts,
    level,
    selectedOption,
    fullname,
    dial_code,
    phone_number,
    debug,
    images,
    isEtest,
    devMode,
    pre_test,
    attempt_of_test,
    certificate_plan
});

class Question extends Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.respond = this.respond.bind(this);
        this.playSound = this.playSound.bind(this);
        this.reloadSound = this.reloadSound.bind(this);
        this.showStartOver = this.showStartOver.bind(this);

        this.state = {
            isErrorSound: false,
            availablePlay: false,
            onPlaying: false,
        }
    }
    /**
     * This method will fetch files from question api and filter whether the files is text or sounds|images
     *
     * @return {void}
     */
    componentDidMount() {
        const { etest, certificate_plan, type } = this.props;

        if (etest.status == 'progress' && etest.question.files.length) {
            if (this.props.playSoundOnStart) {
                let files = etest.question.files;
                this.props.setSoundAndText(files).then(() => {
                    if (this.props.sounds.length) this.initSound(this.props.sounds);
                    this.props.setPlaySoundOnStart(false);
                })
                this.disableNextButton(certificate_plan, type)
            }

            if (hasLastQuestion()) {
                if (this.props.sounds.length) this.initSound(this.props.sounds)
            }
        }
    }

    /**
     * Handle change for selected option
     *
     * @param {*} payload
     * @return {void}
     */
    handleChange(payload) {
        let selected = Object.assign({}, payload);
        selected.content = payload.text;
        selected.id = payload.id;
        this.props.selectQuestion(selected)
    }
    /** @return {*} */
    loadQuestion() {
        const { email, token, type, fullname, dial_code, phone_number, devMode, pre_test, attempt_of_test, certificate_plan } = this.props;
        let formData = setFormData(email, token, type, fullname, dial_code, phone_number, devMode, this.props.level, pre_test)
        this.props.loadQuestion("question", formData).then(() => {
            if (this.props.etest.status == 'progress') {
                this.props.setSoundAndText(this.props.etest.question.files).then(() => {
                    if (this.props.sounds.length) this.initSound(this.props.sounds);
                })
                this.disableNextButton(certificate_plan, type)
            }
            // Submit test results when test time is up, or
            // when test is completed and last attempt of test
            if (isComplete(this.props.etest.status) && type == 'pt' && this.props.etest.attempt == attempt_of_test) {
                this.props.submitQuestion();
            }
        })
    }

    /** @return {void} */
    disableNextButton(certificate_plan, type) {
        let nextButton = document.getElementById('nextButton');
        nextButton.disabled = true
        nextButton.classList.remove('neo-btn-next');
    }

    /** @return {void} */
    stopSound() {
        this.sound.stop();
        this.props.handlePlayButton(false);
    }

    /**
     * Reload sounds
     *
     * @return {void}
     */
    reloadSound() {
        this.sound.load()
    }

    /**
     * Response the question
     * when click the option button
     *
     * @return {void}
     */
    respond() {
        if (this.sound) this.stopSound()
        const { etest, type, token, email, devMode, dial_code, phone_number, fullname, pre_test, level } = this.props;

        const { question } = etest;

        const formData = new FormData();

        let response = {
            token,
            email,
            dial_code,
            phone_number,
            fullname,
            question_id: question.id,
            flow_id: question.flow_id,
            group_id: question.group_id,
            option_id: this.props.selectedOption,
            etest: devMode == 'true',
            attempt: etest.attempt || 0,
            pre_test,
            level
        }

        for (let [key, value] of Object.entries(response)) {
            formData.append(key, value)
        }

        $axiosL.post(`${config.api_base_url}/${type}/response`, formData).then(res => {
            this.props.resetPlaySoundCount();
            this.loadQuestion();
            this.props.changeSelectedOption('');
            this.setState({ availablePlay: false });
        }).catch(err => {
            if (!err.response) {
                this.props.errorAdd($lang('error.connection_issue'));
            } else {
                this.props.errorAdd($lang('error.' + err.response.data.message) || 'Something went wrong. clue: ' + err.response.data.message)
            }
            this.props.changeSelectedOption('');
        })
    }

    /**
     * Play sound from incoming audio
     *
     * @param {Array} files
     * @return {any}
     */
    playSound(files) {
        if (this.state.onPlaying) return;

        if (this.props.isPlaying) {
            return;
        }

        if (this.props.playSoundCount >= 2) {
            this.props.errorAdd($lang('error.repeat_audio'));
            return;
        }

        if (this.state.availablePlay) {
            this.props.handlePlayButton(true);
            this.initSound(files);
        }
    }

    /**
     * Init howler sounds
     *
     * @param {array} files
     * @return {void}
     */
    initSound(files) {
        const self = this;

        let sounds = [].concat(files);
        this.sound = new Howl({
            src: [
                sounds[0]
            ],
            autoplay: true,
            preload: true,
            volume: 1.0,
            pool: 1,
            html5: true,
            onload: function () {
                self.setState({ isErrorSound: false });
            },
            onloaderror: function (idx, message) {
                console.error("Audio play error.", message);

                if (confirm("an error occurred while loading the audio, do you want to reload the page?")) {
                    location.href = location.pathname;
                    return;
                }

                self.sound.unload();
                self.setState({ isErrorSound: true });
                self.sound.play();
            },
            onplayerror: function (error) {
                // play audio automatically on page load
                self.setState({ isErrorSound: true });

                // destroy the cache
                self.sound.unload();
                self.sound.once('unlock', function () {
                    self.sound.play();
                });
            },
            onplay: function (idx) {
                self.setState({ onPlaying: true });
            },
            onend: function () {
                self.props.handlePlayButton(false);
                self.sound.unload()
                sounds.shift();
                if (sounds.length <= 0) {
                    self.setState({ onPlaying: false });
                    self.setState({ availablePlay: true });
                    self.props.addPlaySoundCount();
                } else {
                    self.initSound(sounds)
                }
            }
        });

        this.setPlay(true);

    }

    /**
     * Set is playing property
     *
     * @param {boolean} bool
     * @return {void}
    */
    setPlay(bool) {
        const self = this;

        if (this.sound) {
            this.sound.on('play', function () {
                self.props.handlePlayButton(bool);
            })
        }
    }

    displayType(type) {
        if (type == 'pt') {
            return 'Assessment Test';
        }

        if (type == 'et') {
            return 'Certification Test';
        }
        return 'Undefined Test';
    }

    /**
     * Set is showStartOver property
     *
     * @return {boolean}
    */
    showStartOver() {
        const { etest, type, attempt_of_test } = this.props;
        return isComplete(etest.status) && type == 'pt' && etest.attempt < attempt_of_test;
    }

    render({ etest, sounds, handleModal, finishTest, type, isPlaying, texts, debug, images, devMode, selectedOption, certificate_plan }) {
        const { question } = etest;
        const { playSound, handleChange, respond, displayType, reloadSound, showStartOver } = this;

        const isDevelopment = () => {
            return (debug == 'true' && devMode == 'true') && config.app_env != 'production';
        }

        const { isErrorSound } = this.state;

        function List() {
            if (etest.status == 'progress') {
                return <div className="et-container et-px-4 et-mx-auto">
                    {
                        finishTest ?
                            <CompleteLayout title="Time is up" />
                            :
                            <div className="mb-5 notranslate">
                                {(isDevelopment() && !isComplete(etest.status)) && <Debug />}
                                <h2 className="et-text-primary et-text-center et-font-bold et-text-2xl et-my-2">
                                    {displayType(type)}
                                </h2>

                                <div className={`${allowFromHosts() ? 'et-hidden md:et-flex' : 'et-flex'} et-justify-end et-max-w-lg et-mx-auto timer-question`}>
                                    <Timer />
                                </div>
                                {question.files.length &&
                                    <table style=" margin-left: auto;margin-right: auto;">
                                        <tr>
                                            <td>
                                                <div className="et-flex et-flex-wrap et-justify-center et-max-w-xs et-mx-auto">
                                                    {!!sounds.length && !isErrorSound &&
                                                        <div className="et-flex et-justify-center et-cursor-pointer et-flex-col et-items-center" onClick={() => { !isPlaying && playSound(sounds) }}>
                                                            <span id="neoplayaudio">
                                                                {
                                                                    isPlaying ? <PauseCircleIcon size={40} color="#387fde" className="w-full" /> : <PlayCircleIcon size={40} color="#387fde" className="w-full" />
                                                                }
                                                            </span>
                                                            <span className="et-text-center et-mt-2 et-text-gray-500">{$lang('audio_instruction')}</span>
                                                        </div>
                                                    }

                                                    {/* Audio play error. Try to unlocking audio. */}
                                                    {/* After user reload the page */}
                                                    {!!sounds.length &&
                                                        isErrorSound &&
                                                        <div className="et-flex et-justify-center et-cursor-pointer et-items-center et-flex-col">
                                                            <button onClick={() => reloadSound()}>
                                                                <PlayCircleIcon size={56} color="#387fde" className="w-full" />
                                                            </button>
                                                            <span className="et-text-center et-mt-2 et-text-gray-500">{$lang('audio_instruction')}</span>
                                                        </div>
                                                    }
                                                    {
                                                        !!images.length &&
                                                        <div className="et-flex et-justify-center et-flex-wrap et-w-full et-mt-2 et-items-start">
                                                            {
                                                                images.map(image => (
                                                                    <img src={image} alt="Question Image" style='max-width:50%;' />
                                                                ))
                                                            }
                                                        </div>
                                                    }

                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                {!!texts.length &&
                                                    < div id="neoaudioquestiontext" className={sounds.length ? 'neo-question-with-files' : ''} >
                                                        {
                                                            question.files.map(file => (
                                                                file.text.length > 0 ?
                                                                    <span style="display: block;margin-bottom: 5px;"> {file.text} </span>
                                                                    : ""
                                                            ))
                                                        }
                                                    </div>
                                                }
                                            </td>
                                        </tr>
                                    </table>
                                }
                                <Option contents={question.option.contents} option={question.option} handleChange={handleChange} />
                                <div className={`et-question-option et-items-center et-px-4 et-mt-5`}>
                                    {
                                        type == 'pt' && certificate_plan != 'neojr_plus'
                                            ? <button onClick={() => handleModal(true)} className="neo-btn-icon-text option-btn">
                                                <RepeatIcon size={20} />
                                                <span>{$lang('button.start_over')}</span>
                                            </button>
                                            : <div className="et-text-primary et-text-center et-font-bold et-text-xl lg:text-2xl"></div>
                                    }
                                    {
                                        type == 'et' &&
                                        <div className="et-text-primary et-text-center et-font-bold et-text-xl lg:text-2xl">
                                            {etest.meta_info.submitted + 1} / {etest.meta_info.total_questions}
                                        </div>
                                    }
                                    <button
                                        onClick={respond}
                                        className={classNames(
                                            `neo-btn-icon-text option-btn neo-btn-next`,
                                            !!selectedOption && 'next-btn-active',
                                        )}
                                        id="nextButton"
                                    >
                                        <RightIcon size={20} />
                                        <span>{$lang('button.next')}</span>
                                    </button>
                                </div>
                            </div>
                    }
                </div>
            } else if (showStartOver()) {
                return <CompleteLayout title={$lang('finish_test')} />
            } else {
                return <Result />
            }
        }

        return List()
    }
}

export default connect(mapToProps, actions)(Question)
